/* eslint eqeqeq: off */
import React from "react";
import './index.css';
import Modal, {ModalAction, ModalContent, ModalControls} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import Input from "../../../Components/Control/Input";
import Select from "../../../Components/Control/Select";
import {connect} from "react-redux";
import Resource from "../../../Resource";
import PropTypes from 'prop-types';
import {Tool} from "../../../App";
import Notif from "../../../Components/Notif";
import Configuration from "../../../Server/Configuration";
import MyComponent from '../../../Components/MyComponent';

class ModalPolicy extends MyComponent {
    constructor(props) {
        super(props);
        props.refer.current = this;

        //todo update permissions
        // this.perms = {
        //     INSERT_FIRST_PERIOD_INVENTORY: Tool.can('INSERT_FIRST_PERIOD_INVENTORY')
        // };

        this.state = {
            title: {
                INSERT: 'ثبت قانون جدید',
                UPDATE: 'قانون فرآورده'
            },
            bloodGroups: [
                {id: '', text: '...'},
                ...props.base.bloodGroups.map(item => {
                    return {id: item.id, text: item.name};
                })
            ],
            productTypes: [
                {id: '', text: '...'},
                ...props.base.productTypes.map(item => {
                    return {id: item.id, text: item.name, data: item};
                })
            ],
            fields: {},
            error: false,
            updated: false // this checks weather modal has been changed something or not
        };

        this.ref = {
            modal: React.createRef(),
            insert: React.createRef(),
            update: React.createRef(),
            close: React.createRef(),
            bloodGroupId: React.createRef(),
            productTypeId: React.createRef(),
            minStorageAmount: React.createRef(),
            remainDaysToExpire: React.createRef(),
            remainDaysToExpireCollectionDate: React.createRef()
        };
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null,
        onSuccess: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    };

    validations = {
        bloodGroupId: x => Boolean(x && x[0]?.id) || 'گروه خونی انتخاب نشده',
        productTypeId: x => Boolean(x && x[0]?.id) || 'نوع فرآورده انتخاب نشده',
        minStorageAmount: x => Boolean(x) || 'حداقل موجودی فرآورده وارد نشده است',
        remainDaysToExpire: x => Boolean(x) || 'شروع هشدار انقضا فرآورده انتخاب نشده است.',
        remainDaysToExpireCollectionDate: x => Boolean(x) || 'شروع هشدار تازگی فرآورده انتخاب نشده است.'
    };

    componentDidMount() {
        Configuration.usersList({hospitalId: this.props.hospitalId})
            .then(list => {
                this.setState({
                    users: [{id: '', text: '...'},
                        ...list.map(item => {
                            return {id: item.userId, text: item.fullName};
                        })]
                });
            });
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const {state} = this;

        return state.action !== nextState.action ||
            state.error !== nextState.error ||
            state.fields !== nextState.fields ||
            state.users !== nextState.users;
    }

    render() {
        const {state} = this;

        return <Modal ref={this.ref.modal}
                      name={'ModalPolicy'}
                      size={'medium'}
                      title={state.title[state.action]}
                      error={state.error}
                      onClose={_ => {
                          if (this.state.updated)
                              this.props.onSuccess();
                      }}>
            <ModalContent>
                <div className={'dis-f'}>
                    <Select ref={this.ref.bloodGroupId} value={state.fields?.bloodGroupId} className={'pad-4 fb-10'} label={'گروه خونی'} options={state.bloodGroups} validation={this.validations.bloodGroupId} onChange={this.setField.bind(this, 'bloodGroupId')}/>
                    <Select ref={this.ref.productTypeId} value={state.fields?.productTypeId} className={'pad-4 fb-10'} label={'نوع فرآورده'} options={state.productTypes} validation={this.validations.productTypeId} onChange={this.setField.bind(this, 'productTypeId')}/>
                    <Input ref={this.ref.minStorageAmount} type={'number'} value={state.fields?.minStorageAmount} align={"center"} className={'pad-4 fb-6'} label={'حداقل موجودی'} validation={this.validations.minStorageAmount} onChange={this.setField.bind(this, 'minStorageAmount')}/>
                    <Input ref={this.ref.remainDaysToExpire} type={'number'} value={state.fields?.remainDaysToExpire} align={"center"} className={'pad-4 fb-7'} label={'شروع هشدار انقضا (روز)'} validation={this.validations.remainDaysToExpire} onChange={this.setField.bind(this, 'remainDaysToExpire')}/>
                    <Input ref={this.ref.remainDaysToExpireCollectionDate} type={'number'} value={state.fields?.remainDaysToExpireCollectionDate} align={"center"} className={'pad-4 fb-7'} label={'شروع هشدار تازگی (روز)'} validation={this.validations.remainDaysToExpireCollectionDate} onChange={this.setField.bind(this, 'remainDaysToExpireCollectionDate')}/>
                </div>
            </ModalContent>
            <ModalControls>
                {state.action === ModalAction.INSERT && <Button refer={this.ref.insert} className={'mar-4'} theme={'blue'} onClick={this.insertClickHandler.bind(this)}>ثبت فرآورده</Button>}
                {state.action === ModalAction.UPDATE && <Button refer={this.ref.update} className={'mar-4'} theme={'yellow'} onClick={this.updateClickHandler.bind(this)}>ویرایش فرآورده</Button>}
                <Button refer={this.ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
            </ModalControls>
        </Modal>;
    }

    close(success) {
        this.ref.modal.current.close();

        if (success === true || this.state.updated)
            this.props.onSuccess();

        this.props.onClose();
    }

    insertClickHandler() {
        const {ref, state} = this;

        if (this.validate()) {
            ref.insert.current.loading();
            this.setState({error: null});

            Configuration.addPolicy({
                bloodGroupId: state.fields?.bloodGroupId[0]?.id,
                productTypeId: state.fields?.productTypeId[0]?.id,
                minStorageAmount: state.fields?.minStorageAmount,
                remainDaysToExpire: state.fields?.remainDaysToExpire,
                remainDaysToExpireCollectionDate: state.fields?.remainDaysToExpireCollectionDate
            }).then(_ => {
                ref.insert.current.loading(false);

                new Notif(Resource.STRING.FETCH.INSERT_SUCCESSFUL).show();

                this.setState({updated: true});
            }).catch(message => {
                ref.insert.current.loading(false);

                this.setState({error: message});
            });
        }
    }

    open(data, action) {
        if (action === ModalAction.INSERT) {
            this.setState({
                data,
                action,
                fields: {},
                error: null,
                updated: false
            });
        } else if (action === ModalAction.UPDATE) {
            this.setState({
                data,
                action,
                updated: false,
                fields: {
                    bloodGroupId: [{id: data.bloodGroupId}],
                    productTypeId: [{id: data.productTypeId}],
                    minStorageAmount: data.minStorageAmount,
                    remainDaysToExpire: data.remainDaysToExpire,
                    remainDaysToExpireCollectionDate:data.remainDaysToExpireCollectionDate
                },
                error: null
            });
        }

        return this.ref.modal.current.open();
    }

    updateClickHandler() {
        const {state} = this;

        if (this.validate()) {
            this.ref.update.current.loading();
            this.setState({error: null});

            Configuration.updatePolicy({
                productMaintanceConditionId: state.data?.productMaintanceConditionId,
                bloodGroupId: state.fields?.bloodGroupId[0]?.id,
                productTypeId: state.fields?.productTypeId[0]?.id,
                minStorageAmount: state.fields?.minStorageAmount,
                remainDaysToExpire: state.fields?.remainDaysToExpire,
                remainDaysToExpireCollectionDate: state.fields?.remainDaysToExpireCollectionDate,
            }).then(_ => {
                this.ref.update.current.loading(false);

                new Notif(Resource.STRING.FETCH.UPDATE_SUCCESSFUL).show();

                this.close(true);
            }).catch(message => {
                this.ref.update.current.loading(false);

                this.setState({error: message});
            });
        }
    }

    validate() {
        const validate = Tool.validate(
            this.ref.bloodGroupId,
            this.ref.productTypeId,
            this.ref.minStorageAmount,
            this.ref.remainDaysToExpire,
            this.ref.remainDaysToExpireCollectionDate
            );

        if (validate !== true)
            new Notif({message: validate.message, theme: 'error'}).show();

        return validate === true;
    }
}

const mapStateToProps = state => {
    return {
        base: state.base
    };
};

export default connect(mapStateToProps)(ModalPolicy);